import DxfArrayScanner, { type ScannerGroup } from '../../DxfArrayScanner';
import isMatched from '../../shared/isMatched';
import parseDimension from './common';
import { DimensionEntity } from './types';

export default class DimensionParser {
    static ForEntityName = 'DIMENSION';

    static parseEntity(scanner: DxfArrayScanner, curr: ScannerGroup): DimensionEntity {
        const entity = {} as DimensionEntity;
        let current = curr;

        while (!isMatched(current, 0, 'EOF')) {
            if (current.code === 0) {
                scanner.rewind();
                return entity;
            }

            parseDimension(entity, current, scanner);
            current = scanner.next();
        }

        return entity;
    }
}
